import React from 'react';
// import { useTranslation } from 'react-i18next';
import { Col, Row } from 'antd';
import { AgreementCheckboxLI } from './agreementCheckboxLI';
// import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';

export const AgreementCard = () => {
  // const { t } = useTranslation();

  return (
    <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]}>
      <Col xs={24} md={24}>
        <div style={{ fontSize: '17px', fontFamily: 'Roboto400', paddingTop: '15px' }}>
          <AgreementCheckboxLI />
        </div>
      </Col>
    </Row>
  );
};
